<script lang='ts'>
import { isBadgeDone, type Badge } from "../services";
import { markdown } from '../util';

export let badge: Badge;
let done;
$: done = isBadgeDone(badge);
</script>

<div class="card row shadow" class:padd={done && badge.link} on:click>
  {#if done && badge.link}
    <div class="banner">Bonus content unlocked, click to access it</div>
  {/if}

  <div class="img" style="background-image: url({badge.image})" />
  <div class='col flex-1'>
    <div class='points-container row vcenter'>
      {badge.points}
      <!-- svelte-ignore a11y-missing-attribute -->
      <img src="/img/point.png" />
    </div>

    <div class="title">{badge.name}</div>
    <div class="desc flex-1">{@html markdown(done ? badge.unlocked_description : badge.locked_description)}</div>

    <div class="totals">{badge.progress[0]} / {badge.progress[1]}</div>
    <div class="bar">
      <div class="inner-bar" style="width: {Math.floor(badge.progress[0] / badge.progress[1] * 100)}%" />
    </div>
  </div>
</div>

<style>

.banner {
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--secondary);
  color: var(--text-secondary);
  padding: 5px 10px;
  font-size: 14px;
  border-radius: 0 0 8px 0;
}
.card {
  position: relative;
  padding: 16px;
  gap: 24px;
  border-radius: 8px;
  background-color: white;
  width: 400px;
}

.card.padd {
  padding-top: 40px;
}

.img {
  width: 140px;
  height: 140px;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
}

.title {
  font-weight: bold;
}

.desc {
  
}

.totals {
  align-self: flex-end;
  font-size: 12px;
}

.bar {
  position: relative;
  height: 12px;
  width: 100%;
  background-color: grey;
  overflow: hidden;
  border-radius: 4px;
}

.inner-bar {
  height: 100%;
  background-color: red;
  transition: width 450ms;
}

.points-container {
  align-self: flex-end;
  font-weight: bold;
  margin-bottom: 8px;
  /* position: absolute; */
  /* top: 8px;
  right: 8px; */
}

.points-container img {
  margin-left: 8px;
}
</style>